// extracted by mini-css-extract-plugin
module.exports = {"tabs__list":"Tabs_tabs__list__pMWBG","tabs__link":"Tabs_tabs__link__HlZtM","tabs__link___active":"Tabs_tabs__link___active__hhp97"};